// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"1896c0a0","290":"ec439833","716":"1789a211"}[chunkId] + ".chunk.js";
};